module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c12e386b8137e71b289edca2cca5e500.png";